import React, { FC, ReactNode } from 'react';
import { styled } from 'linaria/react';
import Link from 'next/link';
import Image from 'next/image';
import { withTheme } from '@shared/lib/theme';
import { Text } from '@shared/ui/atoms';
import { ICON_TCP } from '@shared/config';
import { TspListPagePayee } from '../model/tsp.types';
interface TspCardProps {
  badge?: ReactNode;
  payee: TspListPagePayee;
  fullWidth?: boolean;
  onClick?: () => void;
}
const TspCard: FC<TspCardProps> = ({
  badge,
  payee,
  fullWidth = false,
  onClick
}) => <TspCardOuterWrapper fullWidth={fullWidth}>
    <GradientBackgroundWrapper fullWidth={fullWidth}>
      <Link passHref href={`/${payee.features?.tsp_url}`} onClick={onClick}>
        <TspCardInnerWrapper>
          {badge && <BadgeWrapper>{badge}</BadgeWrapper>}
          <ImageWrapper>
            <Image src={`${ICON_TCP}${payee.features?.vertical_cover}`} alt={payee.providerName} width={210} height={315} />
          </ImageWrapper>
        </TspCardInnerWrapper>
      </Link>
    </GradientBackgroundWrapper>
    <TextWrapper>
      <Text family="MTSCompact" weight="medium" size="pS">
        {payee.providerName}
      </Text>
    </TextWrapper>
  </TspCardOuterWrapper>;
export default TspCard;
interface TspCardWrapperProps {
  fullWidth: boolean;
}
const _exp = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? '100%' : '13.125rem';
const _exp2 = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? '100%' : '129.33px';
const TspCardOuterWrapper = /*#__PURE__*/styled('div')({
  name: "TspCardOuterWrapper",
  class: "t1146nsw",
  propsAsIs: false,
  vars: {
    "t1146nsw-0": [_exp()],
    "t1146nsw-1": [_exp2()]
  }
});
const _exp3 = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? 'auto' : '19.6875rem';
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => `0px 0px 47.85px 0px ${theme.colors.background.primary}`;
const _exp7 = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? '100%' : '129.33px';
const _exp8 = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? 'auto' : '194px';
const _exp9 = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? '2 / 3' : 'auto';
const GradientBackgroundWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "GradientBackgroundWrapper",
  class: "g1gfyhsh",
  propsAsIs: false,
  vars: {
    "g1gfyhsh-0": [_exp3()],
    "g1gfyhsh-1": [_exp9()],
    "g1gfyhsh-2": [_exp6()],
    "g1gfyhsh-3": [_exp7()],
    "g1gfyhsh-4": [_exp8()]
  }
}));
const TspCardInnerWrapper = /*#__PURE__*/styled('div')({
  name: "TspCardInnerWrapper",
  class: "tnw1rzf",
  propsAsIs: false
});
const BadgeWrapper = /*#__PURE__*/styled('div')({
  name: "BadgeWrapper",
  class: "b1lfw754",
  propsAsIs: false
});
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "imcau4u",
  propsAsIs: false
});
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "tk4h6c2",
  propsAsIs: false
});

require("./TspCard.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./TspCard.tsx");